module.exports = __webpack_public_path__ + "wirewax-offline/8201557/static/media/pxiByp8kv8JHgFVrLCz7Z1JlFd2JQEl8qw.62d7a4c7.woff2";